import { createReducer, createActions } from 'reduxsauce';
import update from 'immutability-helper';
import type { ProductType } from 'contracts/ProductTypes';

const { Types, Creators } = createActions(
  {
    request: ['id', 'onSuccess', 'onFailure'],
    success: ['data'],
    failure: ['errorMessage'],
    softReset: [],
    reset: [],
  },
  {
    prefix: 'FETCH_PRODUCTTYPE_',
  }
);

export interface FetchProductTypeState {
  data: ProductType | null;
  loading: boolean;
  errorMessage: string | null;
}

export interface FetchProductTypeRequestAction {
  id: number;
  onSuccess?: () => void;
  onFailure?: () => void;
}

interface SuccessAction {
  data: ProductType;
}

interface FailureAction {
  errorMessage: string;
}

const INITIAL_STATE: FetchProductTypeState = {
  data: null,
  loading: false,
  errorMessage: null,
};

const request = (state: FetchProductTypeState) =>
  update(state, {
    loading: { $set: true },
    errorMessage: { $set: null },
  });

const success = (state: FetchProductTypeState, action: SuccessAction) =>
  update(state, {
    loading: { $set: false },
    data: { $set: action.data },
  });

const failure = (state: FetchProductTypeState, action: FailureAction) =>
  update(state, {
    loading: { $set: false },
    errorMessage: { $set: action.errorMessage },
  });

const softReset = (state: FetchProductTypeState) =>
  update(state, {
    loading: { $set: false },
  });

const reset = () => INITIAL_STATE;

export const fetchProductType = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.SOFT_RESET]: softReset,
  [Types.RESET]: reset,
});

export const FetchProductTypeTypes = Types;
export const FetchProductTypeActions = Creators;
